import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, Debounce } from '../../helpers';
import moment from 'moment';
import Message from '../Common/Message/Message';
import deleteIcon from '../../images/icons/delete.svg';
import checkGreenIcon from '../../images/icons/check-green.svg';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './TicketDistribution.css';
import { ticket } from '../../lib/labels/ShowTix4UTicket';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class TicketDistribution extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            totalTickets: 0,
            token: '',
            ticket_distributions: [],
            flexpass_distributions: [],
            message: {
                title: '',
                content: '',
                type: ''
            },
            hasSubmitted: false,
        };
    }
    
    componentDidMount() {
        if(this.props.token){
            this.setState({
                token: this.props.token,
            }, () => {
                this.getDistributionStatus();
            });
        } else {
            this.setMessage(window.general_strings.msg.oops, 'Your token is invalid', 'error');
        }
    }

    getDistributionStatus = () => {
        let token = this.state.token;
        let totalTickets = this.state.totalTickets;
        this.setMessage('', '', 'loading');

        const getDistribution = async (token) => {
            try {
                const getStatusResponse = await getStatus(token);
                console.log('getStatusResponse:', getStatusResponse);
                if (getStatusResponse.data.ticket_distributions || getStatusResponse.data.flexpass_distributions) {
                    totalTickets = getStatusResponse.data.ticket_distributions.length + getStatusResponse.data.flexpass_distributions.length;
                    let ticket_distributions = this.groupByKey(getStatusResponse.data.ticket_distributions, 'event_date_id');
                    ticket_distributions = this.convertDistribution(Object.values(ticket_distributions));
                    let flexpass_distributions = this.groupByKey(getStatusResponse.data.flexpass_distributions, 'flexpass_id');
                    flexpass_distributions = this.convertDistribution(Object.values(flexpass_distributions));
                    this.setState({
                        token,
                        totalTickets,
                        ticket_distributions,
                        flexpass_distributions,
                    });
                    this.setMessage('', '', '');
                } else {
                    this.setMessage('Ooops', getStatusResponse.data.error.message, 'error');
                }
            } catch (error) {
                console.log(error);
            }
        }

        async function getStatus(token) {
            return await ApiRequest(`/tickets/distribution-status`, {
                method: 'POST',
                data: {
                    token,
                }
			});
        }

        getDistribution(token);
    }

    convertDistribution = (distribution) => {
        let distribution_arr = [];
        distribution.forEach((result) => {
            let distribution_obj = {};
            distribution_obj.tickets = result;
            distribution_obj.tickets.forEach((ticket) => {
                if (!ticket.first_name) {
                    ticket.first_name = '';
                }
                if (!ticket.last_name) {
                    ticket.last_name = '';
                }
                ticket.message = {};
                ticket.message.type = '';
                ticket.message.content = '';

                ticket.type = 'email';

                ticket.validation = {};
                ticket.validation.email = {};
                ticket.validation.email.msg = '';
                ticket.validation.email.valid = true;
                
                if (!ticket.email) {
                    ticket.email = '';
                } else {
                    ticket.validation.email.valid = true;
                }

                ticket.validation.phone = {};
                ticket.validation.phone.msg = '';
                ticket.validation.phone.valid = true;
                if (!ticket.phone) {
                    ticket.phone = '';
                } else {
                    ticket.phone = ticket.phone.replace('+1', '');
                    ticket.validation.phone.valid = true;
                }
                if (ticket.phone !== '') {
                    ticket.type = 'phone';
                }
            });
            
            // If ticket, not flexpass
            if (result[0].event) {
                distribution_obj.poster_graphic_url = result[0].event.poster_graphic_url;
                distribution_obj.event_name = result[0].event.name;
                distribution_obj.event_datetime_local = result[0].event_date.event_datetime_local;
                distribution_obj.event_type = result[0].event.event_type;
            } else {
                distribution_obj.poster_graphic_url = '';
                distribution_obj.event_name = result[0].flexpass_name;
                distribution_obj.event_datetime_local = '';
                distribution_obj.event_type = 'Flexpass';
            }
            
            distribution_obj.transaction_id = result[0].transaction_id;
            distribution_arr.push(distribution_obj);
        });
        return distribution_arr;
    }

    groupByKey = (array, key) => {
        return array
          .reduce((hash, obj) => {
            if(obj[key] === undefined) return hash; 
            return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
          }, {})
    };

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    validate = Debounce((type, value, field, eventIndex, ticketIndex, validationRegEx) => {
        const ticket_distributions = this.state.ticket_distributions;
        const flexpass_distributions = this.state.flexpass_distributions;
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            if (type === 'flexpass') {
                if (flexpass_distributions[eventIndex].tickets[ticketIndex].first_name !== '' || flexpass_distributions[eventIndex].tickets[ticketIndex].last_name !== '') {
                    flexpass_distributions[eventIndex].tickets[ticketIndex].validation[field]['msg'] = strings.errorInvalid;
                    isValid = false;
                }
            } else {
                if (ticket_distributions[eventIndex].tickets[ticketIndex].first_name !== '' || ticket_distributions[eventIndex].tickets[ticketIndex].last_name !== '') {
                    ticket_distributions[eventIndex].tickets[ticketIndex].validation[field]['msg'] = strings.errorInvalid;
                    isValid = false;
                }
            }
        }
        if (type === 'flexpass') {
            flexpass_distributions[eventIndex].tickets[ticketIndex].validation[field]['valid'] = isValid;
        } else {
            ticket_distributions[eventIndex].tickets[ticketIndex].validation[field]['valid'] = isValid;
        }
        
        this.setState({ 
            ticket_distributions,
            flexpass_distributions,
        });
    }, 250);

    handleChange = (type, e, field, eventIndex, ticketIndex) => {
        let ticket_distributions = this.state.ticket_distributions;
        let flexpass_distributions = this.state.flexpass_distributions;
        if (type === 'flexpass') {
            flexpass_distributions[eventIndex].tickets[ticketIndex][field] = e.target.value;
            flexpass_distributions[eventIndex].tickets[ticketIndex].message.type = '';
            flexpass_distributions[eventIndex].tickets[ticketIndex].message.content = '';
        } else {
            ticket_distributions[eventIndex].tickets[ticketIndex][field] = e.target.value;
            ticket_distributions[eventIndex].tickets[ticketIndex].message.type = '';
            ticket_distributions[eventIndex].tickets[ticketIndex].message.content = '';
        }
        
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(type, e.target.value, field, eventIndex, ticketIndex, validationRegEx);
        }
        this.setState({
            ticket_distributions,
            flexpass_distributions,
        });
    }

    handleTypeSelect = (type, e, eventIndex, ticketIndex) => {
        let ticket_distributions = this.state.ticket_distributions;
        let flexpass_distributions = this.state.flexpass_distributions;
        if (type === 'flexpass') {
            flexpass_distributions[eventIndex].tickets[ticketIndex].type = e.target.value;
            if (e.target.value === 'email') {
                flexpass_distributions[eventIndex].tickets[ticketIndex].validation.phone.valid = true;
            } else {
                flexpass_distributions[eventIndex].tickets[ticketIndex].validation.email.valid = true;
            }
        } else {
            ticket_distributions[eventIndex].tickets[ticketIndex].type = e.target.value;
            if (e.target.value === 'email') {
                ticket_distributions[eventIndex].tickets[ticketIndex].validation.phone.valid = true;
            } else {
                ticket_distributions[eventIndex].tickets[ticketIndex].validation.email.valid = true;
            }
        }
        
        this.setState({
            ticket_distributions,
            flexpass_distributions,
        });
    }

    submitDistribution = () => {
        this.setMessage('', '', 'loading');
        let token = this.state.token;
        let ticket_distributions = this.state.ticket_distributions;
        let flexpass_distributions = this.state.flexpass_distributions;
        let ticketsPosted = 0;
        let ticketsReadyToSubmit = 0;
        
        ticket_distributions.forEach((ticket_distribution) => {
            ticket_distribution.tickets.forEach(async (ticket) => {
                let isReadyToSubmit = true;
                if (ticket.type === 'email') {
                    ticket.phone = undefined;
                    if (ticket.email !== '' && ticket.first_name !== '' && ticket.last_name !== '') {
                        isReadyToSubmit = true;
                    }
                    if (ticket.email === '') {
                        isReadyToSubmit = false;
                        if (ticket.first_name !== '' || ticket.last_name !== '') {
                            ticket.message.type = 'error';
                            ticket.message.content = strings['email-or-phone-required'];
                            ticket.validation.email.valid = false;
                        }
                    }
                }
                if (ticket.type === 'phone') {
                    ticket.email = undefined;
                    if (ticket.phone !== '' && ticket.first_name !== '' && ticket.last_name !== '') {
                        isReadyToSubmit = true;
                    }
                    if (ticket.phone === '') {
                        isReadyToSubmit = false;
                        if (ticket.first_name !== '' || ticket.last_name !== '') {
                            ticket.message.type = 'error';
                            ticket.message.content = strings['email-or-phone-required'];
                            ticket.validation.phone.valid = false;
                        }
                    }
                }
                
                if (isReadyToSubmit) {
                    const postDistributionResponse = await postDistribution(ticket, token);
                    console.log('postDistributionResponse:', postDistributionResponse);
                    ticketsReadyToSubmit++;
                    if (!postDistributionResponse.data.error) {
                        ticketsPosted++;
                        ticket.message.type = 'success';
                        ticket.message.content = 'Updated successfully!';
                        this.setState({
                            ticket_distributions,
                        });
                    } else {
                        ticket.message.type = 'error';
                        ticket.message.content = strings[postDistributionResponse.data.error.code];
                        if (postDistributionResponse.data.error.details) {
                            ticket.message.content = postDistributionResponse.data.error.details[0].message;
                        }
                        if (postDistributionResponse.data.error.message) {
                            ticket.message.content = postDistributionResponse.data.error.message;
                        }
                        ticket.validation.phone.valid = false;
                        ticket.validation.email.valid = false;
                        this.setMessage('', '', '');
                    }
                } else {
                    this.setState({
                        ticket_distributions,
                        flexpass_distributions,
                    });
                    this.setMessage('', '', '');
                }

                if (ticketsPosted === this.state.totalTickets) {
                    console.log('ticket_distributions', ticket_distributions)
                    /* this.setState({
                        ticket_distributions,
                    }); */
                    this.setMessage('', '', '');
                    this.setState({
                        hasSubmitted: true,
                    });
                }
                        
                async function postDistribution(ticket, token) {
                    return await ApiRequest(`/tickets/distribute`, {
                        method: 'POST',
                        data: {
                            ticket_id: ticket.ticket_id,
                            first_name: ticket.first_name,
                            last_name: ticket.last_name,
                            email: ticket.email,
                            phone: ticket.phone ? ticket.phone : '',
                            token,
                        }
                    });
                }
            });
        });

        flexpass_distributions.forEach((flexpass_distribution) => {
            flexpass_distribution.tickets.forEach(async (ticket) => {
                let isReadyToSubmit = true;
                if (ticket.type === 'email') {
                    ticket.phone = undefined;
                    if (ticket.email !== '' && ticket.first_name !== '' && ticket.last_name !== '') {
                        isReadyToSubmit = true;
                    }
                    if (ticket.email === '') {
                        isReadyToSubmit = false;
                        if (ticket.first_name !== '' || ticket.last_name !== '') {
                            ticket.message.type = 'error';
                            ticket.message.content = strings['email-or-phone-required'];
                            ticket.validation.email.valid = false;
                        }
                    }
                }
                if (ticket.type === 'phone') {
                    ticket.email = undefined;
                    if (ticket.phone !== '' && ticket.first_name !== '' && ticket.last_name !== '') {
                        isReadyToSubmit = true;
                    }
                    if (ticket.phone === '') {
                        isReadyToSubmit = false;
                        if (ticket.first_name !== '' || ticket.last_name !== '') {
                            ticket.message.type = 'error';
                            ticket.message.content = strings['email-or-phone-required'];
                            ticket.validation.phone.valid = false;
                        }
                    }
                }
                
                if (isReadyToSubmit) {
                    const postDistributionResponse = await postDistribution(ticket, token);
                    console.log('postDistributionResponse:', postDistributionResponse);
                    ticketsReadyToSubmit++;
                    if (!postDistributionResponse.data.error) {
                        ticketsPosted++;
                        ticket.message.type = 'success';
                        ticket.message.content = 'Updated successfully!';
                        this.setState({
                            ticket_distributions,
                        });
                    } else {
                        ticket.message.type = 'error';
                        ticket.message.content = strings[postDistributionResponse.data.error.code];
                        if (postDistributionResponse.data.error.details) {
                            ticket.message.content = postDistributionResponse.data.error.details[0].message;
                        }
                        if (postDistributionResponse.data.error.message) {
                            ticket.message.content = postDistributionResponse.data.error.message;
                        }
                        ticket.validation.phone.valid = false;
                        ticket.validation.email.valid = false;
                        this.setMessage('', '', '');
                    }
                } else {
                    this.setState({
                        ticket_distributions,
                        flexpass_distributions,
                    });
                    this.setMessage('', '', '');
                }

                if (ticketsPosted === this.state.totalTickets) {
                    console.log('ticket_distributions', ticket_distributions)
                    /* this.setState({
                        ticket_distributions,
                    }); */
                    this.setMessage('', '', '');
                    this.setState({
                        hasSubmitted: true,
                    });
                }
                        
                async function postDistribution(ticket, token) {
                    return await ApiRequest(`/tickets/distribute`, {
                        method: 'POST',
                        data: {
                            transaction_flexpass_id: ticket.transaction_flexpass_id,
                            first_name: ticket.first_name,
                            last_name: ticket.last_name,
                            email: ticket.email,
                            phone: ticket.phone ? ticket.phone : '',
                            token,
                        }
                    });
                }
            });
        });
    }

    clearTicketDistribution = async (type, eventIndex: Number, ticketIndex: Number) => {
        let token = this.state.token;
        let ticket_distributions = this.state.ticket_distributions;
        let ticket;
        if (type === 'ticket') {
            ticket_distributions[eventIndex].tickets[ticketIndex].first_name = '';
            ticket_distributions[eventIndex].tickets[ticketIndex].last_name = '';
            ticket_distributions[eventIndex].tickets[ticketIndex].email = '';
            ticket_distributions[eventIndex].tickets[ticketIndex].phone = '';
            ticket_distributions[eventIndex].tickets[ticketIndex].message.type = 'success';
            ticket_distributions[eventIndex].tickets[ticketIndex].message.content = 'Cleared successfully!';
            ticket = ticket_distributions[eventIndex].tickets[ticketIndex]
        }

        let flexpass_distributions = this.state.flexpass_distributions;
        if (type === 'flexpass') {
            flexpass_distributions[eventIndex].tickets[ticketIndex].first_name = '';
            flexpass_distributions[eventIndex].tickets[ticketIndex].last_name = '';
            flexpass_distributions[eventIndex].tickets[ticketIndex].email = '';
            flexpass_distributions[eventIndex].tickets[ticketIndex].phone = '';
            flexpass_distributions[eventIndex].tickets[ticketIndex].message.type = 'success';
            flexpass_distributions[eventIndex].tickets[ticketIndex].message.content = 'Cleared successfully!';
            ticket = flexpass_distributions[eventIndex].tickets[ticketIndex];
        }

        const cancelDistributionResponse = await cancelDistribution(type, ticket, token);
        console.log('cancelDistributionResponse:', cancelDistributionResponse);
        if (!cancelDistributionResponse.data.error) {
            this.setState({
                ticket_distributions,
                flexpass_distributions,
            });
        }

        async function cancelDistribution(type, ticket, token) {
            let data = {};
            data.token = token;
            if (type === 'flexpass') {
                data.transaction_flexpass_id = ticket.transaction_flexpass_id;
            } else {
                if (type === 'flexpass') {
                    data.ticket_id = ticket.ticket_id;
                }
            }
            console.l
            return await ApiRequest(`/tickets/cancel-distribution`, {
                method: 'POST',
                data,
            });
        }
    }

    renderTickets = () => {
        let isSubmitDisabled = false;
        if (this.state.ticket_distributions.length > 0) {
            this.state.ticket_distributions.forEach((ticket_distribution) => {
                ticket_distribution.tickets.forEach((ticket) => {
                    if (!ticket.validation.email.valid) {
                        isSubmitDisabled = true;
                    }
                    if (!ticket.validation.phone.valid) {
                        isSubmitDisabled = true;
                    }
                });
            });
        }
        if (this.state.flexpass_distributions.length > 0) {
            this.state.flexpass_distributions.forEach((flexpass_distribution) => {
                flexpass_distribution.tickets.forEach((ticket) => {
                    if (!ticket.validation.email.valid) {
                        isSubmitDisabled = true;
                    }
                    if (!ticket.validation.phone.valid) {
                        isSubmitDisabled = true;
                    }
                });
            });
        }
        if (this.state.message.type === 'loading') {
            isSubmitDisabled = true;
        }
        return (
            <React.Fragment>
                {this.state.ticket_distributions.length > 0 || this.state.flexpass_distributions.length > 0 ? (
                    <React.Fragment>
                        <div className="showtix-cart__body basket-summary my-4">
                            <h3 className="showtix-cart__title">{strings.title}</h3>
                            <p className="showtix-cart__content" dangerouslySetInnerHTML={{__html: strings.content1}} />
                        
                            {this.state.ticket_distributions.map((ticket_distribution, i) => (
                                <div key={i} className="showtix-cart-item">
                                    <div className="showtix-cart-item__header d-flex">
                                        <div className="showtix-cart-item__poster">
                                            {ticket_distribution.poster_graphic_url ?
                                                <img src={ticket_distribution.poster_graphic_url} alt='' />
                                                :
                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} alt='' />
                                            }
                                        </div>
                                        <div className="showtix-cart-item__infos">
                                            <h3 className="showtix-cart-item__title">{ticket_distribution.event_name}</h3>
                                            <p className="showtix-cart-item__date">
                                                {moment(ticket_distribution.event_datetime_local.substring(0, 19)).format('LLLL')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="showtix-cart-item__body">
                                        <div className="table-responsive">
                                            <table className="showtix-table showtix-table__tickets showtix-table__striped">
                                                <thead>
                                                    <tr>
                                                        <th>{strings.ticket}</th>
                                                        <th>{strings.price}</th>
                                                        <th>{strings.firstName}</th>
                                                        <th>{strings.lastName}</th>
                                                        <th style={{
                                                            width: 114
                                                        }}>{strings.notifyBy}</th>
                                                        <th> 
                                                            {strings.phoneEmail}
                                                            <span id={`tooltip-email-${i}`} className="showtix-tooltip showtix-background__primary-1">!</span>
                                                            <Tooltip placement="top" target={`tooltip-email-${i}`}>
                                                                Email will be sent the day before the event.<br />
                                                                Text will be sent the day before the event.
                                                            </Tooltip>
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {ticket_distribution.tickets.map((ticket, index) => (
                                                    <React.Fragment>
                                                        {ticket.message.content !== '' && (
                                                            <tr>
                                                                <td colSpan={7}>
                                                                    {ticket.message.type === 'error' ? (
                                                                        <div className="showtix-note error">
                                                                            {ticket.message.content}
                                                                        </div>
                                                                    ): (
                                                                        <div className="showtix-note success">
                                                                            <img
                                                                                src={checkGreenIcon}
                                                                                alt=""
                                                                                style={{width: 20, height: 20}}
                                                                            /> {ticket.message.content}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )}
                                                        <tr key={index}>
                                                            <td>
                                                                {ticket.full_seat_name}<br />
                                                                <a className="showtix-button showtix-button__small showtix-background__primary-1" target="_blank" href={`/electronic-ticket/${this.state.token}/${ticket.ticket_id}`}><span>{strings.eticket}</span></a>
                                                            </td>
                                                            <td>
                                                                {
                                                                    new Intl.NumberFormat('en-US', {
                                                                        style: 'currency',
                                                                        currency: 'USD'
                                                                    })
                                                                    .format(ticket.price)
                                                                }
                                                                - {ticket.pricing_option_desc}
                                                            </td>
                                                            <td>
                                                                <div className="showtix-form__group">
                                                                    <label className="showtix-label sr-only" htmlFor={`ticket-${index}-first_name`}>
                                                                    {strings.firstName}
                                                                    </label>
                                                                    <div className="showtix-form__input">
                                                                        <input
                                                                            id={`ticket-${index}-first_name`}
                                                                            className="showtix-input"
                                                                            type="text"
                                                                            name={`ticket-${index}-first_name`}
                                                                            onChange={(e) => this.handleChange('ticket', e, 'first_name', i, index)}
                                                                            value={ticket.first_name}
                                                                            disabled={ticket.status === 'sent'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="showtix-form__group">
                                                                    <label className="showtix-label sr-only" htmlFor={`ticket-${index}-last_name`}>
                                                                    {strings.lastName}
                                                                    </label>
                                                                    <div className="showtix-form__input">
                                                                        <input
                                                                            id={`ticket-${index}-last_name`}
                                                                            className="showtix-input"
                                                                            type="text"
                                                                            name={`ticket-${index}-last_name`}
                                                                            onChange={(e) => this.handleChange('ticket', e, 'last_name', i, index)}
                                                                            value={ticket.last_name}
                                                                            disabled={ticket.status === 'sent'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="showtix-form__select">
                                                                    <select
                                                                        className="showtix-input"
                                                                        value={ticket.type}
                                                                        onChange={e => this.handleTypeSelect('ticket', e, i, index)}
                                                                        disabled={ticket.status === 'sent'}
                                                                    >
                                                                        <option value="email">{strings.email}</option>
                                                                        <option value="phone">{strings.phone3}</option>
                                                                    </select>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {ticket.type === 'email' ? (
                                                                    <div className={"showtix-form__group " + (ticket.validation.email.valid === false ? 'showtix-form__error' : '')}>
                                                                        <label className="showtix-label sr-only" htmlFor={`ticket-${index}-email`}>
                                                                            {strings.email}
                                                                        </label>
                                                                        <div className="showtix-form__input">
                                                                            <input
                                                                                id={`ticket-${index}-email`}
                                                                                className="showtix-input"
                                                                                type="text"
                                                                                name={`ticket-${index}-email`}
                                                                                validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                                                                onChange={(e) => this.handleChange('ticket', e, 'email', i, index)}
                                                                                value={ticket.email}
                                                                                disabled={ticket.status === 'sent'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className={"showtix-form__group " + (ticket.validation.phone.valid === false ? 'showtix-form__error' : '')}>
                                                                        <label className="showtix-label sr-only" htmlFor={`ticket-${index}-phone`}>
                                                                            {strings.phone2}
                                                                        </label>
                                                                        <div className="showtix-form__input">
                                                                            <input
                                                                                id={`ticket-${index}-phone`}
                                                                                className="showtix-input"
                                                                                type="text"
                                                                                name={`ticket-${index}-phone`}
                                                                                onChange={(e) => this.handleChange('ticket', e, 'phone', i, index)}
                                                                                value={ticket.phone}
                                                                                validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                                                                disabled={ticket.status === 'sent'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {this.renderClearDistribution('ticket', i, index)}
                                                                {ticket.status === 'sent' && (
                                                                    <span className="showtix-badge showtix-background__success">
                                                                        {strings.sent}
                                                                    </span>    
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {this.state.flexpass_distributions.map((flexpass_distribution, i) => (
                                <div key={i} className="showtix-cart-item">
                                    <div className="showtix-cart-item__header d-flex">
                                        <div className="showtix-cart-item__poster">
                                            <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} alt='' />
                                        </div>
                                        <div className="showtix-cart-item__infos">
                                            <h3 className="showtix-cart-item__title">{flexpass_distribution.event_name}</h3>
                                        </div>
                                    </div>
                                    <div className="showtix-cart-item__body">
                                        <div className="table-responsive">
                                            <table className="showtix-table showtix-table__tickets showtix-table__striped">
                                                <thead>
                                                    <tr>
                                                        <th>{strings.ticket}</th>
                                                        <th>{strings.price}</th>
                                                        <th>{strings.firstName}</th>
                                                        <th>{strings.lastName}</th>
                                                        <th style={{
                                                            width: 114
                                                        }}>{strings.notifyBy}</th>
                                                        <th> 
                                                            {strings.phoneEmail}
                                                            <span id={`tooltip-email-${i}`} className="showtix-tooltip showtix-background__primary-1">!</span>
                                                            <Tooltip placement="top" target={`tooltip-email-${i}`}>
                                                                Email will be sent the day before the event.<br />
                                                                Text will be sent the day before the event.
                                                            </Tooltip>
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {flexpass_distribution.tickets.map((ticket, index) => (
                                                    <React.Fragment>
                                                        {ticket.message.content !== '' && (
                                                            <tr>
                                                                <td colSpan={7}>
                                                                    {ticket.message.type === 'error' ? (
                                                                        <div className="showtix-note error">
                                                                            {ticket.message.content}
                                                                        </div>
                                                                    ): (
                                                                        <div className="showtix-note success">
                                                                            <img
                                                                                src={checkGreenIcon}
                                                                                alt=""
                                                                                style={{width: 20, height: 20}}
                                                                            /> {ticket.message.content}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )}
                                                        <tr key={index}>
                                                            <td>
                                                                <a className="showtix-button showtix-button__small showtix-background__primary-1" target="_blank" href={`/electronic-ticket/${this.state.token}`}><span>{strings.eticket}</span></a>
                                                            </td>
                                                            <td>
                                                                {
                                                                    new Intl.NumberFormat('en-US', {
                                                                        style: 'currency',
                                                                        currency: 'USD'
                                                                    })
                                                                    .format(ticket.price)
                                                                }
                                                            </td>
                                                            <td>
                                                                <div className="showtix-form__group">
                                                                    <label className="showtix-label sr-only" htmlFor={`flexpass-${index}-first_name`}>
                                                                    {strings.firstName}
                                                                    </label>
                                                                    <div className="showtix-form__input">
                                                                        <input
                                                                            id={`flexpass-${index}-first_name`}
                                                                            className="showtix-input"
                                                                            type="text"
                                                                            name={`flexpass-${index}-first_name`}
                                                                            onChange={(e) => this.handleChange('flexpass', e, 'first_name', i, index)}
                                                                            value={ticket.first_name}
                                                                            disabled={ticket.status === 'sent'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="showtix-form__group">
                                                                    <label className="showtix-label sr-only" htmlFor={`flexpass-${index}-last_name`}>
                                                                    {strings.lastName}
                                                                    </label>
                                                                    <div className="showtix-form__input">
                                                                        <input
                                                                            id={`flexpass-${index}-last_name`}
                                                                            className="showtix-input"
                                                                            type="text"
                                                                            name={`flexpass-${index}-last_name`}
                                                                            onChange={(e) => this.handleChange('flexpass', e, 'last_name', i, index)}
                                                                            value={ticket.last_name}
                                                                            disabled={ticket.status === 'sent'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="showtix-form__select">
                                                                    <select
                                                                        className="showtix-input"
                                                                        value={ticket.type}
                                                                        onChange={e => this.handleTypeSelect('flexpass', e, i, index)}
                                                                        disabled={ticket.status === 'sent'}
                                                                    >
                                                                        <option value="email">{strings.email}</option>
                                                                        <option value="phone">{strings.phone3}</option>
                                                                    </select>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {ticket.type === 'email' ? (
                                                                    <div className={"showtix-form__group " + (ticket.validation.email.valid === false ? 'showtix-form__error' : '')}>
                                                                        <label className="showtix-label sr-only" htmlFor={`flexpass-${index}-email`}>
                                                                            {strings.email}
                                                                        </label>
                                                                        <div className="showtix-form__input">
                                                                            <input
                                                                                id={`flexpass-${index}-email`}
                                                                                className="showtix-input"
                                                                                type="text"
                                                                                name={`flexpass-${index}-email`}
                                                                                validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                                                                onChange={(e) => this.handleChange('flexpass', e, 'email', i, index)}
                                                                                value={ticket.email}
                                                                                disabled={ticket.status === 'sent'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className={"showtix-form__group " + (ticket.validation.phone.valid === false ? 'showtix-form__error' : '')}>
                                                                        <label className="showtix-label sr-only" htmlFor={`flexpass-${index}-phone`}>
                                                                            {strings.phone2}
                                                                        </label>
                                                                        <div className="showtix-form__input">
                                                                            <input
                                                                                id={`flexpass-${index}-phone`}
                                                                                className="showtix-input"
                                                                                type="text"
                                                                                name={`flexpass-${index}-phone`}
                                                                                onChange={(e) => this.handleChange('flexpass', e, 'phone', i, index)}
                                                                                value={ticket.phone}
                                                                                validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                                                                disabled={ticket.status === 'sent'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {this.renderClearDistribution('flexpass', i, index)}
                                                                {ticket.status === 'sent' && (
                                                                    <span className="showtix-badge showtix-background__success">
                                                                        {strings.sent}
                                                                    </span>    
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    
                            
                        <div className="row">
                            <div className="col-12">
                                <div className="mb-2 d-flex showtix-buttons">
                                    <button
                                        className={`showtix-button showtix-background__primary-1`}
                                        onClick={() => this.submitDistribution()}
                                        disabled={isSubmitDisabled}
                                    >
                                        <span>{strings.submit}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                ) : (
                    <div className="showtix-cart__body basket-summary my-4">
                        <h3 className="showtix-cart__title">Sorry!</h3>
                        <p className="showtix-cart__content">There's no ticket to distribute.</p>
                    </div>
                )}
            </React.Fragment>
        );
    }

    renderClearDistribution = (type, eventIndex, ticketIndex) => {
        let ticket_distributions = this.state.ticket_distributions;
        let flexpass_distributions = this.state.flexpass_distributions;
        let ticket;
        if (type === 'ticket') {
            ticket = ticket_distributions[eventIndex].tickets[ticketIndex];
        } else {
            ticket = flexpass_distributions[eventIndex].tickets[ticketIndex];
        }
        let canClearDistribution = false;

        if (!ticket.hasDistribution) {
            canClearDistribution = true;
        } else {
            if (this.props.user && (this.props.user.role === 'admin' || this.props.user.role === 'client')) {
                canClearDistribution = true;
            }
        }
        if (ticket.status === 'sent') {
            canClearDistribution = false;
        }
        if (canClearDistribution) {
            return (
                <button
                    className="showtix-button showtix-button__simple"
                    onClick={() => this.clearTicketDistribution(type, eventIndex, ticketIndex)}
                >
                    <img
                        className="delete-icon"
                        src={deleteIcon}
                        alt=""
                    />
                </button>
            );
        } else {
            return null;
        }
    }
	
    render() {
		return (
            typeof this.props.token !== 'undefined' && (
                <React.Fragment>
                    <hr />
                    {this.state.hasSubmitted && this.props.isFromCheckout ? (
                        <div className="showtix-section container">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="showtix-cart__body basket-summary my-4">
                                        <h3 className="showtix-cart__title">CONTACTLESS TICKET SHARING</h3>
                                        <p className="showtix-cart__content">Ticket(s) will be sent to your party the day before the event. You can update the contact information using the link in your order confirmation email. Enjoy your event!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="showtix-section container">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <Message
                                        message={this.state.message}
                                    />
                                </div> 
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {this.renderTickets()}
                                </div>
                            </div>
                        </div>   
                    )}
                </React.Fragment>
            )
		);
  	}
}

export default TicketDistribution;



// WEBPACK FOOTER //
// ./src/components/TicketDistribution/TicketDistribution.js